export default "__VITE_ASSET__zTUf5_NM__"